module.exports = __webpack_public_path__ + "static/media/icon-upload.049e23fe.svg";